import { get } from 'lodash';
import { API_CALL_SUCCEEDED, API_CALL_FAILED, START_API_CALL } from '../api/apiCallActions';
import { isAudioSavingRequest } from '../api/apiUtils';
import { SET_RESULT } from '../api/resultActions';
import { TRO } from '../../constants/measure';
import {
    START_RECORDING,
    STOP_RECORDING,
    SET_RECORDING_STREAM,
    SET_PERMISSIONS_ERROR,
    RECORDING_ERROR,
    SET_RECORDED_RESULT,
    CLEAR_RECORDED_RESULT,
    CLEAR_PERMISSIONS_ERROR,
    SET_MIC_CHECK_PASSED,
    START_OFFLINE_AUDIO_SAVING,
    END_OFFLINE_AUDIO_SAVING,
    TOGGLE_IS_VR_RESULT_PROCESSING_TIMEOUT,
    INCREMENT_MIC_TEST_ATTEMPT_COUNT,
    CLEAR_MIC_TEST_ATTEMPT_COUNT,
    CLEAR_RECORDING_STREAM,
} from './recordingActions';
import { SET_TRC_CONTENT, SET_TRC_BOOK_RESULT } from '../../trc/trcActions';
import { VR_RESULT_STATUS } from '../../constants/error';

const INCREMENT = 1;

export const defaultState = {
    recordingError: undefined,
    recordedResult: undefined,
    recordingStream: undefined,
    permissionsError: undefined,
    didPermissionsFail: false,
    isRecordingSaved: undefined,
    isRecordingInProgress: false,
    isRecordingSavingInProgress: false,
    isOfflineAudioSyncInProgress: false,
    isVrResultProcessingTimeout: false,
    micTestAttemptCount: 0,
    isMicCheckPassed: false,
};

const recordingReducer = (state = defaultState, action) => {
    switch (action.type) {
    case START_RECORDING:
        return {
            ...state,
            isRecordingInProgress: true,
            isRecordingSaved: undefined,
            isOfflineAudioSyncInProgress: false,
        };
    case SET_TRC_CONTENT:
    case CLEAR_RECORDED_RESULT:
        return {
            ...state,
            isRecordingSaved: defaultState.isRecordingSaved,
            recordedResult: defaultState.recordedResult,
            isRecordingSavingInProgress: defaultState.isRecordingSavingInProgress,
        };
    case STOP_RECORDING:
        return {
            ...state,
            isRecordingInProgress: false,
        };
    case SET_RECORDED_RESULT:
        return {
            ...state,
            recordedResult: action.recordedResult,
            isRecordingSavingInProgress: true,
        };
    case RECORDING_ERROR:
        return {
            ...state,
            recordingError: action.recordingError,
        };
    case SET_RECORDING_STREAM:
        return {
            ...state,
            recordingStream: action.recordingStream,
        };
    case CLEAR_RECORDING_STREAM:
        return {
            ...state,
            recordingStream: defaultState.recordingStream,
        };
    case SET_PERMISSIONS_ERROR:
        return {
            ...state,
            permissionsError: action.permissionsError.name,
            didPermissionsFail: true,
        };
    case SET_MIC_CHECK_PASSED:
        return {
            ...state,
            isMicCheckPassed: true,
        };
    case START_API_CALL:
        if (isAudioSavingRequest(action)) {
            return {
                ...state,
                isRecordingSavingInProgress: false,
            };
        };
        return state;
    case API_CALL_SUCCEEDED:
    case API_CALL_FAILED:
        if (isAudioSavingRequest(action)) {
            return {
                ...state,
                isRecordingSaved: action.type === API_CALL_SUCCEEDED,
                recordedResult:
                    action.type === API_CALL_SUCCEEDED
                        ? defaultState.recordedResult // clear if saved successfully
                        : state.recordedResult,
            };
        }
        return state;
    case SET_RESULT:
        if (action.result.measure === TRO.MEASURE) {
            const bookResults = get(action, 'result.measure_result.book_results', []);
            return {
                ...state,
                isRecordingSaved: bookResults.length > 0 &&
                    bookResults.every(result => get(result, 'vrr_result.status') !== VR_RESULT_STATUS.UNAVAILABLE),
            };
        }
        return state;
    case SET_TRC_BOOK_RESULT:
        return {
            ...state,
            isRecordingSaved: get(action.bookResult, 'vrr_result.status') !== VR_RESULT_STATUS.UNAVAILABLE,
        };
    case CLEAR_PERMISSIONS_ERROR:
        return {
            ...state,
            permissionsError: undefined,
            didPermissionsFail: false,
        };
    case START_OFFLINE_AUDIO_SAVING:
        return {
            ...state,
            isOfflineAudioSyncInProgress: true,
        };
    case END_OFFLINE_AUDIO_SAVING:
        return {
            ...state,
            isOfflineAudioSyncInProgress: false,
        };
    case TOGGLE_IS_VR_RESULT_PROCESSING_TIMEOUT:
        return {
            ...state,
            isVrResultProcessingTimeout: true,
        };
    case INCREMENT_MIC_TEST_ATTEMPT_COUNT:
        return {
            ...state,
            micTestAttemptCount: state.micTestAttemptCount + INCREMENT,
        };
    case CLEAR_MIC_TEST_ATTEMPT_COUNT:
        return {
            ...state,
            micTestAttemptCount: defaultState.micTestAttemptCount,
        };
    default:
        return state;
    }
};

export default recordingReducer;
